module.exports = __webpack_public_path__ + "img/logo.7e29c284.png";